import React, { useEffect } from "react";
import { useWebSocket } from "./webSocketContext";
import { X as IoMdClose, Bell as IoNotificationsOutline } from "lucide-react";
import { Link } from "react-router-dom";

const NotificationToast = ({ message, onDismiss }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss(message.id);
    }, 5000); // Auto-dismiss after 5 seconds

    return () => clearTimeout(timer);
  }, [message.id, onDismiss]);

  const handleDismiss = (e) => {
    e.preventDefault(); // Prevent navigation when closing
    e.stopPropagation(); // Stop event from bubbling up to the Link
    onDismiss(message.id);
  };

  return (
    <Link
      to={`/notifications?open=${message.pk}`}
      className="no-underline"
      onClick={() => onDismiss(message.id)} // 3. Dismiss on click
    >
      <div className="w-[380px] bg-white text-[#172b4d] border border-gray-400 rounded-md shadow-lg flex items-center p-3 animate-slideIn transition-all duration-300 cursor-pointer hover:bg-gray-100 active:bg-gray-200">
        {/* Icon */}
        <div className="mr-3 flex-shrink-0 text-blue-500">
          <IoNotificationsOutline
            size={24}
            className="bg-#004F7C animate-bounce"
          />
        </div>

        {/* Message Content */}
        <div className="flex-grow  ">
          {/* Message Title */}
          {/* <p className="font-semibold">{message.heading}</p> */}

          {/* Message Body */}
          <p
            className="text-sm leading-snug overflow-hidden text-ellipsis"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              maxHeight: "2.8em", // Approx height for 2 lines
            }}
          >
            {`New message from ${message.name} regarding ${message.content}`}
          </p>
        </div>

        {/* Dismiss Button */}
        <button
          onClick={handleDismiss}
          className="ml-3 p-1 flex-shrink-0 rounded-full text-[#6b778c] hover:bg-gray-200"
          title="Dismiss"
        >
          <IoMdClose size={20} />
        </button>
      </div>
    </Link>
  );
};

export const NotificationContainer = () => {
  const { receivedMessages, removeMessage } = useWebSocket() || {
    receivedMessages: [],
    removeMessage: () => {},
  };

  const handleDismiss = (id) => {
    // This will dismiss both real and example notifications
    removeMessage(id);
  };

  // We only show a few recent notifications at a time to avoid clutter
  const visibleNotifications = receivedMessages.slice(0, 4);

  if (!visibleNotifications.length) {
    return null;
  }

  return (
    <div className="fixed bottom-5 right-5 z-[9999] flex flex-col-reverse gap-2.5">
      {visibleNotifications.map((msg) => (
        <NotificationToast
          key={msg.id}
          message={msg}
          onDismiss={handleDismiss}
        />
      ))}
    </div>
  );
};
